import React from 'react'
import { Form } from 'semantic-ui-react'


const CustomizedAddressField = ({ value, onChange, label, placeholder }) => {
  return (
    <Form.TextArea
      fluid
      required
      label={label}
      placeholder={placeholder}
      onChange={e => onChange(e.target.value)}
      value={value}
    />
  )
}

export default CustomizedAddressField



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/customizedAddressField.js